import axios from 'axios';
import API from '../Api';

export function getLocation(params) {
    return axios.get(API.GET_LOCATIONS, params)
}
export function addLocation(params) {
    return axios.post(API.ADD_LOCATION, params)
}